<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="用户ID">
        <el-input v-model="queryCondition.userId" />
      </el-form-item>
      <el-form-item label="币种">
        <el-input v-model="queryCondition.coinType" />
      </el-form-item>
      <el-form-item label="项目方等级">
        <el-select v-model="queryCondition.level">
          <el-option v-for="item in levels" :key="item.code" :value="item.code" :label="item.desc" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryCondition.status">
          <el-option v-for="item in status" :key="item.code" :value="item.code" :label="item.desc" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="(queryCondition.pageNo = 1), buildList(queryCondition)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="(operateType = 'create'), (showEdit = true)">新增项目方</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="listInfo">
      <el-table-column prop="userId" label="用户Id" />
      <el-table-column prop="coinType" label="币种" />
      <el-table-column label="项目方等级">
        <template slot-scope="scope">{{ parseLevel(scope.row.level) }}</template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="alterStatus(scope.row.id, scope.row.userId, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="是否可以提现">
        <template slot-scope="scope">
          <el-switch
                  :value="scope.row.withdrawal"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="updateSwitch(scope.row.userId, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" circle size="small" @click="editProject(scope.row)" />
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="delProject(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="25"
      :current-page.sync="queryCondition.pageNo"
      @current-change="changePage"
    />

    <el-dialog title="项目方信息编辑" :visible.sync="showEdit" @close="closeDialog">
      <el-form label-width="130px" :model="editInfo" ref="form">
        <el-form-item label="用户ID" prop="userId" :rules="[{ required: true, message: '用户ID不能为空' }]">
          <el-input v-model="editInfo.userId"></el-input>
        </el-form-item>
        <el-form-item label="币种">
          <coin-select @value="setCoin"></coin-select>
        </el-form-item>
        <el-form-item label="项目方等级" prop="level" :rules="[{ required: true, message: '项目方等级不能为空' }]">
          <el-select v-model="editInfo.level">
            <el-option v-for="item in levels" :key="item.code" :value="item.code" :label="item.desc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联交易对">
          <el-input v-model="editInfo.tradePair" placeholder="多个交易对请用逗号隔开"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitInfo">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <p style="font-weight: bolder;font-size: medium;margin-top: 20px;">项目方快照余额查询</p>
    <el-form :inline="true">
      <el-form-item>
        <el-input style="width: max-content;margin-right: 10px;" v-model="balanceQuery.userId" placeholder="用户ID" />
        {{balanceQuery}}
        <el-date-picker
          v-model="balanceQuery.snapshotTime"
          type="datetime"
          placeholder="选择快照时间"
          style="margin-right: 20px;"
        />
        <el-button type="primary" @click="queryBalanceEvent(1)">查看</el-button>
        <el-button type="success" @click="exportBalanceEvent()">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="balanceInfo">
      <el-table-column label="项目方账号" prop="userId" />
      <el-table-column label="所持币种" prop="coinType" />
      <el-table-column label="币种可用" prop="coinAv" />
      <el-table-column label="币种冻结" prop="coinFr" />
      <el-table-column label="USDT可用" prop="usdtAv" />
      <el-table-column label="USDT冻结" prop="usdtFr" />
      <el-table-column label="BTC可用" prop="btcAv" />
      <el-table-column label="BTC冻结" prop="btcFr" />
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="balanceTotal"
      :page-size="25"
      :current-page.sync="balanceQuery.pageNo"
      @current-change="queryBalanceEvent"
    />

    <el-dialog title="删除" width="420px" :visible.sync="showDel" @close="closeDialog">
      <el-form label-width="130px" :model="editInfo" ref="form">
        <p>是否确认删除此项目方?</p>
        <el-form-item style="margin-top:40px">
          <el-button type="info" @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitDelInfo">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import api from "./api";
import coinSelect from "../../../components/coinSelect";

export default {
  name: "project",
  components: { "coin-select": coinSelect },
  data() {
    return {
      queryCondition: { userId: "", coinType: "", status: true, pageNo: 1, size: 25, level: "" },
      showEdit: false,
      showDel: false,
      status: [
        { code: false, desc: "禁用" },
        { code: true, desc: "启用" }
      ],
      editInfo: { id: null, userId: "", coinType: "", level: null, tradePair: "" },
      levels: [
        { code: 1, desc: "一级项目方" },
        { code: 2, desc: "二级项目方" },
        { code: 3, desc: "三级项目方" },
        { code: 4, desc: "四级项目方" },
        { code: 5, desc: "五级项目方" }
      ],
      operateType: "", //create/update
      balanceQuery: { userId: "", pageNo: 1, snapshotTime: "" }
    };
  },
  computed: { ...mapState("project", ["listInfo", "total", "balanceInfo", "balanceTotal"]) },
  created() {
    this.buildList(this.queryCondition);
  },
  methods: {
    ...mapActions("project", ["buildList", "buildBalance"]),
    alterStatus(id, userId, status) {
      api.updateStatus({ id: id, userId: userId, status: status }).then(() => {
        this.$message.success("状态修改成功");
        this.queryCondition.pageNo = 1;
        this.buildList(this.queryCondition);
      });
    },

      updateSwitch(userId, status) {
          api.updateSwitch({ userId: userId, status: status }).then(() => {
              this.$message.success("提现状态修改成功");
              this.queryCondition.pageNo = 1;
              this.buildList(this.queryCondition);
          });
      },

    closeDialog() {
      this.$refs["form"].resetFields();
      this.editInfo.mainAreaPair = "";
      this.editInfo.innovateAreaPair = "";
      this.showDel = false;
      this.showEdit = false;
    },

    parseLevel(val) {
      for (let i = 0; i < 5; i++) {
        if (val === this.levels[i].code) {
          return this.levels[i].desc;
        }
      }
    },

    editProject(row) {
      this.operateType = "update";
      this.editInfo.id = row.id;
      this.editInfo.userId = row.userId;
      this.editInfo.coinType = row.coinType;
      this.editInfo.level = row.level;
      this.editInfo.tradePair = row.tradePair;
      this.showEdit = true;
    },
    delProject(row) {
      this.operateType = "del";
      this.editInfo.id = row.id;
      this.showDel = true;
    },

    submitInfo() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.editInfo.coinType === "") {
            this.$message.error("项目方支持币种不能为空");
            return;
          }
          if (this.operateType === "create") {
            api.addProject(this.editInfo).then(() => {
              this.$refs["form"].resetFields();
              this.$message.success("新增项目方信息成功");
              this.queryCondition.pageNo = 1;
              this.buildList(this.queryCondition);
              this.closeDialog();
            });
          }

          if (this.operateType === "update") {
            api.updateProject(this.editInfo).then(() => {
              this.$refs["form"].resetFields();
              this.$message.success("修改项目方信息成功");
              this.queryCondition.pageNo = 1;
              this.buildList(this.queryCondition);
              this.closeDialog();
            });
          }
        }
      });
    },

    submitDelInfo() {
      api
        .delProject({
          id: this.editInfo.id
        })
        .then(() => {
          this.$refs["form"].resetFields();
          this.$message.success("删除成功");
          this.queryCondition.pageNo = 1;
          this.buildList(this.queryCondition);
          this.closeDialog();
        });
    },

    changePage() {
      this.buildList(this.queryCondition);
    },

    setCoin(val) {
      console.log("当前输入币种" + val);
      this.editInfo.coinType = val;
    },

    queryBalanceEvent() {
      if(!this.balanceQuery.snapshotTime) this.balanceQuery.snapshotTime="";
      this.buildBalance(this.balanceQuery);
    },

    exportBalanceEvent() {
      api.balanceExport(this.balanceQuery).then(response => {
        const fileName = "项目方余额统计表.xlsx";
        const blob = new Blob([response], { type: "application/vnd.ms-excel" });
        if ("download" in document.createElement("a")) {
          const link = document.createElement("a");
          link.download = fileName;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    }
  }
};
</script>

<style scoped></style>
